export enum EPopupGroupActions {
    SetView = '@connectionPopupGroup/view/set',
    ToggleFilter = '@connectionPopupGroup/filter/toggle',
    SetResult = '@connectionPopupGroup/requestConnection/result/set',
}
